import React from "react";
import { motion } from "framer-motion";
import { TableCell, TableRow } from "@/shared/components/ui/table";
import { cn } from "@/shared/lib/utils";

export const EntityRow = React.memo(({ cells = [], index = 0, className, ...props }) => {
  return (
    <motion.tr
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.02, duration: 0.3, ease: "easeOut" }}
      className={cn(
        "group hover:bg-slate-50/80 transition-all duration-200 border-b border-slate-50 last:border-0",
        className
      )}
      {...props}
    >
      {cells.map((cell) => (
        <TableCell
          key={cell.id}
          className={cn(
            "py-4 align-middle",
            cell.className
          )}
        >
          {cell.content}
        </TableCell>
      ))}
    </motion.tr>
  );
});

EntityRow.displayName = "EntityRow";
